import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { environment } from 'src/environments/environment'
import { ProviderStatusEntry } from './base-shipping-provider.service'

@Injectable({ providedIn: 'root' })
export class ActiveShippingService {
  private readonly activeProviderSubject = new BehaviorSubject<string | null>(null)
  readonly activeProvider$ = this.activeProviderSubject.asObservable()

  constructor(
    private readonly http: HttpClient,
    private readonly builderService: BuilderService,
  ) {}

  /**
   * Fetches all provider statuses for the project and publishes the single
   * enabled+connected provider code through activeProvider$. Publishes null
   * when no provider is active.
   *
   * @param projectId - The merchant project to check.
   */
  async loadActiveProvider(projectId: string): Promise<void> {
    const token = this.builderService.getToken()
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` })
    try {
      const url = `${environment.agentsUrl}shipping/admin/providers?projectId=${projectId}`
      const res = await this.http
        .get<{ data: ProviderStatusEntry[] }>(url, { headers })
        .toPromise()
      const active = res!.data.find((e) => e.enabled && e.connected) ?? null
      this.activeProviderSubject.next(active?.provider ?? null)
    } catch {
      this.activeProviderSubject.next(null)
    }
  }

  /**
   * Returns the currently cached active provider code, or null when none is active.
   * Call loadActiveProvider() first to populate this value.
   */
  getActiveProvider(): string | null {
    return this.activeProviderSubject.getValue()
  }
}
